import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/Reveal";
import SeedField from "@/components/SeedField";
import { MEDIA } from "@/lib/media";
import { SEEDKEEPERS_URL } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTAAcademy() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-60, 60]);

  return (
    <section ref={ref} className="relative min-h-[90vh] flex items-center text-cream overflow-hidden" data-testid="final-cta">
      <motion.img style={{ y: y, scale: 1.15 }} src={MEDIA.sunrise} alt="Australian landscape at sunrise" className="absolute inset-0 w-full h-[120%] object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/65 to-charcoal/40" />
      <SeedField count={12} />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-32 w-full">
        <Reveal className="max-w-4xl">
          <p className="overline text-ochre mb-7">Begin with seed</p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-light leading-[1.22] max-w-4xl">
            Whether you're developing your own skills, strengthening a ranger or restoration team,
            preparing for post-fire recovery, planning mine rehabilitation, or establishing a seed
            bank,{" "}
            <span className="text-ochre">SeedKeepers Academy can help you find the right place to begin.</span>
          </h2>
          <div className="mt-14 flex flex-wrap gap-4">
            <Link to="/courses" data-testid="final-explore" className="bg-cream text-rainforest px-8 py-4 text-sm tracking-wide hover:bg-sandstone transition-colors">
              Explore the Academy
            </Link>
            <Link to="/contact" data-testid="final-talk" className="border border-cream/50 text-cream px-8 py-4 text-sm tracking-wide hover:bg-cream hover:text-rainforest transition-colors">
              Talk With SeedKeepers
            </Link>
          </div>
          <a href={SEEDKEEPERS_URL} target="_blank" rel="noopener noreferrer" data-testid="final-seedkeepers" className="group inline-flex items-center gap-2 mt-10 text-cream/70 hover:text-cream text-sm transition-colors">
            Learn more about SeedKeepers
            <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
